import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, first, switchMap } from 'rxjs/operators';
import { HttpStatusCodesEnum } from 'src/app/utils/httpStatusCodesEnum';
import { AuthenticationmanagerService } from 'src/app/services/authenticationmanager.service';
import { Router } from '@angular/router';

@Injectable()
export class RestErrorAuthInterceptor implements HttpInterceptor {

    constructor(
        private _authService: AuthenticationmanagerService,
        private _router: Router,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === HttpStatusCodesEnum.UNAUTHORIZED) {
                return this.handle401Error(request, next, err);
            }
            return throwError(err);
        }));
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler, originalError: any): Observable<HttpEvent<any>> {
        if (this._authService.isRefreshing()) {
            // Refresh already in progress: wait for it to complete, then retry
            return this._authService.getRefreshingFlag().pipe(
                filter(isRefreshing => !isRefreshing),
                first(),
                switchMap(() => next.handle(request)),
                catchError(() => {
                    this._authService.logout();
                    this._router.navigateByUrl('/login');
                    return throwError(originalError);
                })
            );
        }

        return this._authService.doRefresh().pipe(
            switchMap((res) => {
                if (!res || !res.access_token) {
                    this._authService.logout();
                    this._router.navigateByUrl('/login');
                    return throwError(originalError);
                }
                return next.handle(request);
            }),
            catchError(() => {
                this._authService.logout();
                this._router.navigateByUrl('/login');
                return throwError(originalError);
            })
        );
    }
}
